<template>
  <main id="maindiv">
    <section id="herosection">
      <b-container>
        <b-row id="content">
          <div id="hero" class="col-md-7">
            <h1>{{$lang('hero')}}</h1>
            <p>{{$lang('herop')}}</p>
            <p class="my-5">{{$lang('description')}}</p>
          </div>
          <div class="col-md-5 d-flex justify-content-center mt-3">
            <!-- <img id="logo" src="./assets/hero.png" alt="up pdb logo" width="340px" height="92px"> -->
          </div>
        </b-row>
      </b-container>
    </section>
    <div id="selfservices">
    <section>
      <b-container>
        <Services v-if="userInfo.loggedIn==1"></Services> 
        <Login v-if="userInfo.loggedIn==0"></Login>
      </b-container>
    </section>
    </div>
    <MobileStores v-if="userInfo.loggedIn==1"></MobileStores>
    <section>
      <b-container>
        <p class="text-uppercase text-muted sectionheader">{{$lang('news')}}</p>
        <div class="news">
           <ul class="list-unstyled d-flex flex-wrap">
              <li v-for="one in news" v-bind:key="one.id" class="media pb-5 pt-1">
                <img class="mr-3" alt="..." width="182px" :src="one.image">
                <div class="media-body">
                  <a :href="one.link"><h5 class="mt-0 mb-1">{{one.caption}}</h5></a>
                  <span>{{one.text}}</span>
                </div>
              </li>
            </ul>
        </div>
      </b-container>
    </section> 
    <footer id="mainfooter">
       <div class="container-fluid">
         <p>v{{ version }} {{ buildInfo }}</p>
         <p>Images by Unsplash</p>
       </div>
    </footer> 
  </main>
</template>


<script>
import axios from 'axios'
import { mapState } from 'vuex';
import Services from './Services.vue'
import Login from './Login.vue'
import MobileStores from './MobileStores.vue'

export default {
  components: {Services, Login, MobileStores},
  created() {
    this.fetchNews()
  },
  computed: {
    ...mapState(['userInfo']),
    version() {
      return __APP_VERSION__; // Автоматически из package.json
    },
    buildInfo() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      return `${year}.${month}.${day}.${hour}${minute} ${year}`;
    }
  },
  data() {
    return {
      news: [],
    };
  },
  methods: {
    fetchNews() {
        axios.get("/news/news.json")
         .then(resp => {
             this.news = resp.data;
          })
    },
  },
  locales: {
        en: {
            hero: "Welcome to User Portal",
            herop: "Powered by PDB",
            news: "News and Announcements",
            description: "This User Portal contains links and general information about resources available to IPGL employees and will be updated periodically as more tools become available online. UP PDB portal will offer a range of tools for employee self-service."
          },
        de: {
            hero: "Willkommen im Benutzerportal",
            herop: "Powered by PDB",
            news: "Neuigkeiten und Ankündigungen",
            description: "Dieses Benutzerportal enthält Links und allgemeine Informationen zu Ressourcen, die IPGL-Mitarbeitern zur Verfügung stehen, und wird regelmäßig aktualisiert, sobald weitere Tools online verfügbar sind. UP PDB Portal bietet eine Reihe von Tools für die Selbstbedienung von Mitarbeitern."
          },
        ru: {
            hero: "Добро пожаловать на пользовательский портал", 
            herop: "Powered by PDB",
            news: "Новости",
            description: "Этот пользовательский портал содержит ссылки и общую информацию о ресурсах, доступных для сотрудников IPGL, и будет периодически обновляться по мере появления новых инструментов, доступных в интернете. Портал UP PDB предложит ряд инструментов для самообслуживания сотрудников."
        },
        pl: {
          hero: "Witamy w portalu użytkownika", 
          herop: "Powered by PDB",
          news: "Aktualności",
          description: "Ten portal użytkownika zawiera łącza i ogólne informacje na temat zasobów dostępnych dla pracowników IPGL i będzie okresowo aktualizowany w miarę udostępniania nowych narzędzi w Internecie. Portal UP PDB będzie oferował szereg narzędzi samoobsługi pracowniczej."
        }
      }
};
</script>

<style scoped>
#selfservices{
  background-color: #fafafa;
}
#hero {
  padding: 2rem;
}
#herosection{
  padding-bottom: 2rem;
  background: linear-gradient(to right, rgba(250,250,250,1),rgba(69,90,197,0.8)),url("/dist/heroback.jpg");
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: cover;
  color: #444;
}
.sectionheader {
  padding-left: 1rem;
  margin-bottom: 2rem;
  font-size: 12px;
}
.news {
  margin: 0 1rem;
}
.news li{
  width: 520px;
  padding-right: 14px;
  font-size: 0.9rem;
}
@media screen and (max-width:800px){
  #herosection {
    display: none;
  }
}
@media screen and (max-width:700px){
  .news img{
    width: 91px;
  }
}
#mainfooter{
  background-color: #fafafa;
  margin-top: 2rem;
  padding: 3rem 0;
  text-align: center;
  color: #777;
  font-size: 0.875rem;
}
#mainfooter p{
  margin-bottom: 0.25rem;
}
</style>


// WEBPACK FOOTER //
// src/Home.vue